import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography
} from '@mui/material';
import { updateExpertAnswerStatus } from '../../api/ExpertAnswers';
import { EXPERT_ANSWERS_STATUSES } from './constants';

interface UpdateStatusProps {
  open: boolean;
  onClose: () => void;
  entry: { id: number; status: string } | null;
  onSuccess: () => void;
}

const UpdateStatus: React.FC<UpdateStatusProps> = ({ open, onClose, entry, onSuccess }) => {
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    setStatus(entry?.status || '');
    setErrorMsg('');
  }, [entry, open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!entry) return;
    setLoading(true);
    setErrorMsg('');
    try {
      const res = await updateExpertAnswerStatus(entry.id, status);
      if (res?.status === 200) {
        onSuccess();
        onClose();
      } else {
        setErrorMsg('Failed to update status');
      }
    } catch {
      setErrorMsg('Failed to update status');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Update Status</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Box display='flex' flexDirection='column' gap={2} minWidth={300} mt={1}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={status}
                label='Status'
                onChange={e => setStatus(e.target.value)}
                required>
                {Object.values(EXPERT_ANSWERS_STATUSES).map(s => (
                  <MenuItem key={s} value={s}>
                    {s}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errorMsg && <Typography color='error'>{errorMsg}</Typography>}
            <Box display='flex' justifyContent='flex-end' gap={1}>
              <Button onClick={onClose} disabled={loading}>
                Cancel
              </Button>
              <Button type='submit' variant='contained' disabled={loading || !status}>
                Update
              </Button>
            </Box>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateStatus;
